import { IoExitOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";

import {
  setIsObjectPlacementMode,
  setPlacementStep,
  setTransformMode,
  setTransformAxis,
  setSelectedShape,
  updateShapeParam,
  resetPlacement,
  setEditingPosition,
} from "../../redux/objectPlacement";
import ControlPanel from "./ControlPanel";
import { transformFromModelSpace, transformToModelSpace } from "../utils";
import { useObjectPlacementCRUD } from "../CustomHooks";
import { reduxLocalStorage } from "../utility/storage";

const ObjectPlacementControls = () => {
  const dispatch = useDispatch();
  const projectId = reduxLocalStorage.getItem("project_id");

  const { remove, create, updateObject, fetch } = useObjectPlacementCRUD();

  const objectPlacementState = useSelector((state) => state.objectPlacement);

  const {
    isPlacementMode,
    placementStep,
    editingPosition,
    isPlaced,
    transformMode,
    transformAxis,
    selectedShape,
    shapeParams,
    editingObjectId,
    currentTransformState,
  } = objectPlacementState;

  const visualPosition = transformFromModelSpace(editingPosition ?? [0, 0, 0]);

  const handleTransformModeChange = (mode) => dispatch(setTransformMode(mode));
  const handleTransformAxisChange = (axis) => dispatch(setTransformAxis(axis));
  const handleShapeChange = (shape) => dispatch(setSelectedShape(shape));
  const handleShapeParamsChange = (index, value) =>
    dispatch(updateShapeParam({ index, value }));
  const handlePositionInputChange = (axis, value) => {
    const updatedVisualPosition = [...visualPosition];
    updatedVisualPosition[axis] = value;
    const convertedPosition = transformToModelSpace(updatedVisualPosition);

    dispatch(setEditingPosition(convertedPosition));
  };
  const handlePlaceClick = () => {
    if (editingPosition) {
      const transformState = currentTransformState;

      const apiBasedPosition = transformFromModelSpace(transformState.position);

      const newObject = {
        // id: Date.now(),
        position: apiBasedPosition,
        rotation: transformState.rotation,
        scale: transformState.scale,
        shape: selectedShape,
        params: [...shapeParams],
        projectId: Number(projectId),
      };
      create(newObject);
      fetch();
      dispatch(resetPlacement());
    }
  };
  const handleCancelClick = () => {
    dispatch(resetPlacement());
  };

  const handleUpdateObject = (objectId, updates) => {
    const transformState = currentTransformState;

    const apiBasedPosition = transformFromModelSpace(transformState.position);

    const updatedData = {
      shape: selectedShape,
      params: [...shapeParams],
      position: apiBasedPosition,
      rotation: transformState.rotation,
      scale: transformState.scale,
      id: objectId,
    };

    updateObject(updatedData);
    fetch();
    dispatch(resetPlacement());
  };
  const handleDeleteObject = (objectId) => {
    remove(objectId);
    fetch();
    dispatch(resetPlacement());
  };

  return (
    <>
      {isPlacementMode && (
        <button
          className={`toggle-button button-with-icon ${
            isPlacementMode ? "toggle-button-active" : "toggle-button-inactive"
          }`}
          onClick={() => {
            dispatch(setIsObjectPlacementMode(!isPlacementMode));
            if (isPlacementMode) {
              dispatch(setPlacementStep("selectXZ"));
            }
          }}
        >
          <IoExitOutline size={20} />
          <span>Exit Placement</span>
        </button>
      )}
      {(placementStep !== "selectXZ" || editingObjectId) && (
        <ControlPanel
          onPlace={handlePlaceClick}
          onCancel={handleCancelClick}
          onUpdateObject={handleUpdateObject}
          onDeleteObject={handleDeleteObject}
          transformMode={transformMode}
          onTransformModeChange={handleTransformModeChange}
          transformAxis={transformAxis}
          onTransformAxisChange={handleTransformAxisChange}
          isPlaced={isPlaced}
          selectedShape={selectedShape}
          onShapeChange={handleShapeChange}
          position={editingPosition}
          visualPosition={visualPosition}
          onPositionInputChange={handlePositionInputChange}
          shapeParams={shapeParams}
          onShapeParamsChange={handleShapeParamsChange}
          editingObjectId={editingObjectId}
        />
      )}
    </>
  );
};

export default ObjectPlacementControls;
